function updatePostPublishUnixTimestamp() {
    const single_post = document.querySelector(".single-post, .single-contributor_content");
    if(single_post){
        const publishTime = document.getElementsByClassName("custom-publish-time");
        if( publishTime && publishTime?.[0] ){
            const postPublishUnixTimestamp = publishTime[0].getAttribute("data-published-time");
            const postTimeOutput = awCalculateArticleTime(postPublishUnixTimestamp);
            publishTime[0].innerHTML = postTimeOutput;
        }
    }
    awUpdateArticleTimeOnCategoryPage();
}

document.addEventListener("DOMContentLoaded", updatePostPublishUnixTimestamp);